/* eslint-disable */
export const uniqueArrayByKey = (array: any[], key: string): any[] => {
  return array.filter((v, i, a) => a.findIndex(t => t[key] === v[key]) === i);
};
